import React, {
  ReactElement, useEffect, useLayoutEffect, useState,
} from 'react';
import {
  Route, Routes, useLocation, useNavigate,
} from 'react-router-dom';
import { getTitle, NotFoundPage, waitForElement } from 'slovlex-idsk-react-components';
import { useModalDialogueContext } from 'idsk-react-components';
import routes from './routes';
import {
  PrispevokVestnikaAddPage,
  PrispevokVestnikaUpdatePage,
  PrispevokVestnikaDetailPage,
  PrispevokVestnikaListPage,
} from '../page';
import useFetchProfile from '../hooks/useFetchProfile';
import { useSecurityContext } from '../context/SecurityContext';
import { useUserContext } from '../context/UserContext';
import Layout from '../page/Layout';

const VestnikyRouter = (): ReactElement => {
  const location = useLocation();
  const navigate = useNavigate();
  const [parentIsSettingRoute, setParentIsSettingRoute] = useState(true);
  const [anchorIsSettingRoute, setAnchorIsSettingRoute] = useState(true);
  const { pouzivatel } = useUserContext();
  const {
    accessToken,
    organizationId,
    setAccessToken,
    setOrganizationId,
  } = useSecurityContext();
  const { visible } = useModalDialogueContext();

  useFetchProfile();

  useEffect(() => {
    window.parent.postMessage({
      type: `iframe-to-parent-modal-dialogue-${visible ? 'open' : 'close'}`,
    }, '*');
  }, [visible]);

  const onMessage = (event): void => {
    const message = event?.data;
    if (message) {
      if (message && message.type && message.type === 'parent-to-iframe-internal-route') {
        setParentIsSettingRoute(true);
        navigate(message.route, { replace: true });
      } else if (typeof message === 'string' && message.includes('accessToken=')) {
        setAccessToken(message.substring('accessToken='.length));
      } else if (typeof message === 'string' && message.includes('organizationId=')) {
        setOrganizationId(message.substring('organizationId='.length));
      } else if (message.type && message.type === 'pageYOffset') {
        const newHeight = message.portalMainWindowInnerHeight * (2 / 3);
        const modalDialogueWindow = document.querySelector<HTMLElement>('.modal-dialogue-window');
        const iframe = document.querySelector<HTMLElement>('#app');
        if (modalDialogueWindow && iframe) {
          if (iframe.offsetHeight > newHeight) {
            modalDialogueWindow.style.maxHeight = `${newHeight}px`;
          } else {
            modalDialogueWindow.style.maxHeight = `${iframe.offsetHeight - 10}px`;
          }
        }
      }
    }
  };

  useEffect(() => {
    window.addEventListener('message', onMessage);
    window.addEventListener('click', () => {
      window.parent.postMessage({ type: 'iframe-to-parent-clicked' }, '*');
    });
    window.parent.postMessage({ type: 'iframe-to-parent-initialized' }, '*');
    if (window.self === window.top) {
      window.location.replace(`${process.env.REACT_APP_PORTAL_MAIN_URL}/vestniky`
        + `${location.pathname ? location.pathname : ''}`
        + `${location.search ? location.search : ''}${location.hash ? location.hash : ''}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useLayoutEffect(() => {
    if (document.referrer && document.referrer !== document.location.href
      && location.pathname !== routes.loading.to
      && parentIsSettingRoute && anchorIsSettingRoute) {
      notifyParent();
      setAnchorIsSettingRoute(false);
    }

    if (parentIsSettingRoute && anchorIsSettingRoute) {
      setParentIsSettingRoute(false);
      return;
    }
    notifyParent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, location.hash, location.search, location.state]);

  const notifyParent = (type = 'iframe-to-parent-internal-route'): void => {
    waitForElement('#app > *').then(() => {
      window.parent.postMessage({
        type,
        route: `/vestniky${location.pathname ? location.pathname : ''
        }${location.search ? location.search : ''
        }${location.hash ? location.hash : ''}`,
        title: getTitle(),
      }, '*');
    });
  };

  if (accessToken === undefined || organizationId === undefined) {
    return null;
  }

  if (accessToken && pouzivatel === null) {
    return null;
  }

  return (
    <Routes>
      <Route path={routes.loading.to} element={null} />
      <Route path={routes.prispevokVestnika.list.to} element={<PrispevokVestnikaListPage />} />
      <Route path={routes.prispevokVestnika.add.to} element={<PrispevokVestnikaAddPage />} />
      <Route path={routes.prispevokVestnika.update.to} element={<PrispevokVestnikaUpdatePage />} />
      <Route path={routes.prispevokVestnika.detail.raw} element={<PrispevokVestnikaDetailPage />} />
      <Route path="*" element={<Layout><NotFoundPage /></Layout>} />
    </Routes>
  );
};

export default VestnikyRouter;
